import { defineComponent, computed, ref, createElementBlock, openBlock, normalizeClass, createCommentVNode, withDirectives, unref, renderSlot, createElementVNode, vModelDynamic } from 'vue';

const _hoisted_1 = ["for"];
const _hoisted_2 = ["id", "type", "min", "max", "required"];
const _hoisted_3 = ["for"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "FormInput",
  props: {
    id: {},
    modelValue: { default: "" },
    type: { default: "text" },
    labelFirst: { type: Boolean, default: true },
    labelInside: { type: Boolean, default: false },
    min: {},
    max: {},
    isRequired: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const uid = computed(() => {
      return props.id || Date.now().toString(36) + Math.random().toString(36).substring(2);
    });
    const emit = __emit;
    const labelFirst = props.labelFirst && !props.labelInside;
    const inputValue = ref(props.modelValue);
    const isFilled = computed(() => {
      return inputValue.value != null && (typeof inputValue.value === "string" && inputValue.value.length > 0 || typeof inputValue.value === "number" && inputValue.value > 0);
    });
    const min = computed(() => {
      return props.type === "number" && props.min != null ? props.min : null;
    });
    const max = computed(() => {
      return props.type === "number" && props.max != null ? props.max : null;
    });
    const wrapperClassNames = computed(() => ({
      "form-element": true,
      "form-element--input": true,
      "form-element--filled": isFilled.value
    }));
    const inputClassNames = computed(() => ({
      "form-element__item": true,
      "form-element__item--filled": isFilled.value
    }));
    const labelClassNames = computed(() => ({
      "form-element__label": true,
      "form-element__label--inside": props.labelInside,
      "form-element__label--first": labelFirst,
      "form-element__label--last": !labelFirst
    }));
    const update = () => {
      emit("update:modelValue", inputValue.value);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(wrapperClassNames.value)
      }, [
        unref(labelFirst) ? (openBlock(), createElementBlock("label", {
          key: 0,
          for: uid.value,
          class: normalizeClass(labelClassNames.value)
        }, [
          renderSlot(_ctx.$slots, "default")
        ], 10, _hoisted_1)) : createCommentVNode("", true),
        withDirectives(createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => inputValue.value = $event),
          id: uid.value,
          class: normalizeClass(inputClassNames.value),
          type: _ctx.type,
          min: min.value || void 0,
          max: max.value || void 0,
          required: _ctx.isRequired,
          onInput: update
        }, null, 42, _hoisted_2), [
          [vModelDynamic, inputValue.value]
        ]),
        !unref(labelFirst) ? (openBlock(), createElementBlock("label", {
          key: 1,
          for: uid.value,
          class: normalizeClass(labelClassNames.value)
        }, [
          renderSlot(_ctx.$slots, "default")
        ], 10, _hoisted_3)) : createCommentVNode("", true)
      ], 2);
    };
  }
});

export { _sfc_main as default };
